import { Group } from 'three';
import type { ZebraWalker } from '../../game/RunState';
import { zebraS } from '../../systems/junctions/zebra';
import { animateWalk, createPerson, type Person } from '../people/personModel';

const POOL = 8;

/** Pedestrians on the zebra crossings. */
export class ZebraCrossers {
  readonly group = new Group();
  private readonly pool: Person[] = [];
  private clock = 0;

  constructor() {
    for (let i = 0; i < POOL; i += 1) {
      const person = createPerson(900 + i * 23);
      person.root.visible = false;
      this.pool.push(person);
      this.group.add(person.root);
    }
  }

  update(walkers: readonly ZebraWalker[], dt: number): void {
    this.clock += dt;
    this.pool.forEach((person, i) => {
      const walker = walkers[i];
      person.root.visible = walker !== undefined;
      if (!walker) return;
      const lane = (walker.seed % 3) * 0.45 - 0.45;
      person.root.position.set(walker.x, 0, -(zebraS(walker.junctionSeq) + lane));
      person.root.rotation.y = walker.dir === 1 ? Math.PI / 2 : -Math.PI / 2;
      animateWalk(person, this.clock * 9 + walker.seed, 1);
    });
  }
}
